module.exports = __webpack_public_path__ + "img/hazardEquip30.d414fdfb.png";